<template>
  <v-card color="warning" :disabled="loading">
    <v-progress-linear v-show="loading" color="white" indeterminate></v-progress-linear>
    <v-card-text>
      <v-row>
        <v-col cols="1" class="text-title-card">
          <v-icon x-large dark> mdi-account-hard-hat-outline </v-icon>
        </v-col>
        <v-col class="text-right text-title-card">
            <span v-if="error">
                <v-tooltip top>
                     <template v-slot:activator="{ on, attrs }">
                        <v-icon  color="yellow" v-bind="attrs" v-on="on"> mdi-alert </v-icon>
                      </template>
                      <span>{{errorMessage}}</span>
                </v-tooltip>
            </span>
                    MÃO DE OBRA
           </v-col>
      </v-row>

      <v-row no-gutters class="text-data-card mt-4">
        <v-col>SALÁRIO BASE</v-col>
        <v-col class="text-right">R$ {{formatMoney(salarioBase)}} </v-col>
      </v-row>
      <v-row no-gutters class="text-data-card">
        <v-col cols="8">CUSTO COM RESCISÕES</v-col>
        <v-col class="text-right">R$ {{formatMoney(custoRecisao)}} </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapActions} from 'vuex'
export default {
  name: "PhysicalProgress",
  data() {
    return {
      errorMessage: '',
      error:false,
      loading:false,
      salarioBase:0,
      custoRecisao:0,
    };
  },
  created(){
    this.getData()
  },
  methods:{
    ...mapActions('Dashboard',['getManpower']),
    getData(){
        this.loading = true
        this.getManpower().then((response)=>{
             this.salarioBase = response.data.salario_base
             this.custoRecisao = response.data.custo_estimado_recisao
        })
        .catch((error)=>{
            if(error.response.status == 423){
                this.errorMessage = error.response.data.message;
                this.error = true;
            }
        })
        .finally(()=>{
            this.loading = false
        })
    },
     formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatMoneyPrecision1(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
  }
};
</script>

<style scoped>
.text-title-card {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.text-data-card {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
